import {get_ie_version} from 'lib/utilities';

export default function init_internet_explorer() {
    const ie_version = get_ie_version();

    if (ie_version) {
        document.body.classList.add('ie-' + ie_version);
        document.body.classList.add('is-ie');
    }
}